import { render, staticRenderFns } from "./MultiFactorAuthentication.vue?vue&type=template&id=be3b8098&scoped=true&"
import script from "./MultiFactorAuthentication.vue?vue&type=script&lang=ts&"
export * from "./MultiFactorAuthentication.vue?vue&type=script&lang=ts&"
import style0 from "./MultiFactorAuthentication.vue?vue&type=style&index=0&id=be3b8098&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3b8098",
  null
  
)

export default component.exports